export class HeadingHarnessController {}
